import React from "react";
import { sNew, sNotification } from "../../constants/strings";
import { CreateDrawer } from "../../components/drawer/DrawerComponent";
import { NotificationForm } from "../../forms/NotificationForm";
import { NotificationsRegister } from "./NotificationsRegister";

export const Notifications = () => {
  return (
    <div>
      <CreateDrawer
        title={`${sNew}${sNotification}`}
        form={<NotificationForm />}
      />
      <NotificationsRegister />
    </div>
  );
};
